export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14324.69717ad0.jpg";